export const pdfViewerSettings = {
    components: [
        {
            type: 'tabs',
            key: 'tabs',
            components: [
                {
                    key: 'display',
                    components: [
                        {
                            weight: 0,
                            type: 'textfield',
                            input: true,
                            key: 'label',
                            defaultValue: 'Pdf Viewer',
                            label: 'Label',
                            placeholder: 'Field Label',
                            tooltip: 'The label for this field that will appear next to it.',
                            validate: {
                                required: true
                            }
                        },
                        {
                            type: 'select',
                            input: true,
                            key: 'labelPosition',
                            label: 'Label Position',
                            tooltip: 'Position for the label for this field.',
                            weight: 20,
                            defaultValue: 'top',
                            dataSrc: 'values',
                            data: {
                                values: [
                                    { label: 'Top', value: 'top' },
                                    { label: 'Left (Left-aligned)', value: 'left-left' },
                                    { label: 'Left (Right-aligned)', value: 'left-right' },
                                    { label: 'Right (Left-aligned)', value: 'right-left' },
                                    { label: 'Right (Right-aligned)', value: 'right-right' },
                                    { label: 'Bottom', value: 'bottom' }
                                ]
                            }
                        },
                        {
                            weight: 500,
                            type: 'textfield',
                            input: true,
                            key: 'customClass',
                            label: 'Custom CSS Class',
                            placeholder: 'Custom CSS Class',
                            tooltip: 'Custom CSS class to add to this component.'
                        },
                        {
                            weight: 500,
                            type: 'textfield',
                            input: true,
                            key: 'customStyle',
                            label: 'Custom Style',
                            placeholder: 'Custom Style',
                            defaultValue: 'width: 100%; height: 500px;',
                            tooltip: 'Custom Style to add to this component.'
                        },
                        {
                            weight: 1200,
                            type: 'checkbox',
                            label: 'Hide Label',
                            tooltip: 'Hide the label of this component.',
                            key: 'hideLabel',
                            input: true,
                            defaultValue: false
                        },
                        {
                            weight: 1400,
                            type: 'checkbox',
                            label: 'Disabled',
                            tooltip: 'Disable the form input.',
                            key: 'disabled',
                            input: true
                        }
                    ],
                    label: 'Display',
                    weight: 0
                },
                {
                    key: 'data',
                    components: [
                        {
                            type: 'select',
                            input: true,
                            weight: 0,
                            tooltip: 'Viewer from DMS or S3 or Base64 or Url',
                            key: 'pdfViewerDataFrom',
                            defaultValue: 'base64',
                            label: 'Data From',
                            dataSrc: 'values',
                            data: {
                                values: [
                                    { label: 'DMS', value: 'dms' },
                                    { label: 'S3', value: 's3' },
                                    { label: 'Base64', value: 'base64' },
                                    { label: 'Url', value: 'url' }
                                ]
                            }
                        },
                        {
                            weight: 10,
                            type: 'textfield',
                            input: true,
                            key: 'fileDataKey',
                            label: 'File Data Key',
                            placeholder: 'File Data Key',
                            tooltip: 'To set the key name of the file details',
                            conditional: {
                                json: { '===': [{ var: 'data.pdfViewerDataFrom' }, 'base64'] }
                            }
                        },
                        {
                            weight: 10,
                            type: 'textfield',
                            input: true,
                            key: 'dmsDataKey',
                            label: 'DMS Data Key',
                            placeholder: 'DMS Data Key',
                            conditional: {
                                json: { '===': [{ var: 'data.pdfViewerDataFrom' }, 'dms'] }
                            }
                        },
                        {
                            weight: 10,
                            type: 'textfield',
                            input: true,
                            key: 'url',
                            label: 'URL',
                            placeholder: 'URL',
                            conditional: {
                                json: { '===': [{ var: 'data.pdfViewerDataFrom' }, 'url'] }
                            }
                        }
                    ],
                    label: 'Data',
                    weight: 10
                }
            ]
        }
    ]
};
